import React, { useCallback, useState } from 'react';
import { Button, Field, Form, Input } from '@philips-internal/oswald-ui-components';
import { ButtonTheme, InputType, Key } from '@philips-internal/oswald-ui-constants';
import { isContentfulString, isFunction } from '@philips-internal/oswald-ui-utils';
function LoginDialog(props) {
    const { loginExpression = 'tws.login.login', onLogin, passwordExpression = 'tws.login.password', usernameExpression = 'tws.login.username', } = props;
    const [data, setData] = useState({ password: '', username: '' });
    const isFormValid = isContentfulString(data.username) && isContentfulString(data.password);
    const login = () => {
        if (isFunction(onLogin)) {
            onLogin(data);
        }
    };
    const onFieldKeyDown = (event) => {
        if (event.key !== Key.ENTER || !isFormValid) {
            return;
        }
        login();
    };
    const onFormChange = (event) => {
        setData(event.value);
    };
    const onLoginClick = useCallback(() => {
        login();
    }, [data.password, data.username]);
    const defaultFieldProps = {
        hideLabel: true,
        onKeyDown: onFieldKeyDown,
        width: 12,
    };
    return (React.createElement(Form, { disabled: true, editing: true, locked: true, onChange: onFormChange },
        React.createElement(Field, { ...defaultFieldProps, entry: "username", label: usernameExpression },
            React.createElement(Input, { autoFocus: true })),
        React.createElement(Field, { ...defaultFieldProps, entry: "password", label: passwordExpression },
            React.createElement(Input, { type: InputType.PASSWORD })),
        React.createElement(Button, { enabled: isFormValid, fitParent: true, onClick: onLoginClick, theme: ButtonTheme.PRIMARY, value: loginExpression })));
}
export default LoginDialog;
//# sourceMappingURL=login-dialog.js.map